<template>
  <div class="header"><i :class="icon" /> {{ title }}</div>
</template>

<script>
export default {
  name: "CardHeader",
  props: {
    title: {
      type: String,
      default: "",
    },
    icon: {
      type: String,
      default: null,
    },
  },
}
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  align-items: center;
  font-size: 1.5rem;
  i {
    font-size: 1.5rem;
    margin-right: 1rem;
  }
}
</style>
